import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Notification from './notification';
import NotificationNew from './notification-new';
import NotificationDetails from './notification-detail';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/new`} component={NotificationNew} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details`} component={NotificationDetails} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Notification} />
    </Switch>
  </>
);

export default Routes;
